export const ModalBajaVacaciones = ({children, isOpen, closeModal}) => {

  const handleModalContainerClick = e => e.stopPropagation()
  
  return (
    <article className={`modal-baja-vacaciones ${isOpen && "is-open"}`} onClick={closeModal}>
      <div className="modal-container-baja-vacaciones" onClick={handleModalContainerClick}>
      <button className="modal-close-baja-vacaciones cancelButton" onClick={closeModal}>X</button>
        {children}
      </div>
    </article>
  )
}